import React from 'react';
import Spinner from './Spinner';

// Create a wrapper that replaces a component with a spinner
// if it has a loading prop set to true.
const withLoading = spinnerProps => WrappedComponent => {
    const LoadingComponent = props => {
        if (props.loading) {
            return <Spinner {...spinnerProps} />;
        }
        return <WrappedComponent {...props} />;
    };
    return LoadingComponent;
};

export default withLoading;